<template>
    <button :type="type" class="btn" :class="[color, size]">
        <i class="bi" :class="icon"></i>
        {{ text }}
    </button>
</template>

<script>
export default {
    name: 'ButtonExecDelete',
    props: {
        text: {
            type: String,
            default: '削除...',
        },
        icon: {
            type: String,
            default: 'bi-trash',
        },
        type: {
            type: String,
            default: 'button',
        },
        color: {
            type: String,
            default: 'btn-outline-danger'
        },
        size: {
            type: String,
            default: '',
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
